"use client";

import React from "react";
import { Calculator, Camera, Megaphone, Briefcase, Code, Lightbulb } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * BrokerProgram — Section 3: Wer kann Vermittler werden
 * Drop-in für: src/pages/BrokerProgram/sections/Leistungen.tsx
 *
 * 6 typische Vermittler-Personas mit Begründung warum sie passen.
 */

const personas = [{
  icon: Calculator,
  title: "Steuerberater &amp; Treuhänder",
  description: "Sie betreuen KMU-Kunden, die regelmässig nach Website-Lösungen fragen. Empfehlen Sie das Beste der Schweiz."
}, {
  icon: Briefcase,
  title: "Unternehmensberater",
  description: "Bei jeder Strategiearbeit kommt das Thema Online-Präsenz auf. Liefern Sie eine konkrete Lösung statt Beratung in der Luft."
}, {
  icon: Code,
  title: "IT-Dienstleister",
  description: "Sie machen IT-Setup und -Support für KMU. Erweitern Sie Ihr Angebot um Websites — ohne selbst zu bauen."
}, {
  icon: Megaphone,
  title: "Marketing-Freelancer",
  description: "SEO, Ads, Branding — und dann fehlt die Website? Geben Sie Ihren Kunden eine Lösung, die sofort steht."
}, {
  icon: Camera,
  title: "Fotografen &amp; Designer",
  description: "Sie liefern visuellen Content für KMU. Vermitteln Sie zusätzlich die Website, in der Ihre Bilder leben."
}, {
  icon: Lightbulb,
  title: "Andere KMU-Berater",
  description: "Coachen, Verbände, Branchenexperten — wenn Sie KMU regelmässig sehen, sind Sie der ideale Vermittler."
}];
export default function Leistungen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Für wen das Programm gemacht ist
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Wenn Sie regelmässig mit Schweizer KMU arbeiten, sind Sie der
            richtige Vermittler.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {personas.map((p, i) => <div key={i} className="group bg-card border border-border rounded-xl p-7 hover:border-primary/40 hover:shadow-xl transition-all duration-300">
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                <p.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-2 tracking-tight" dangerouslySetInnerHTML={{
            __html: p.title
          }} />
              <p className="text-base leading-relaxed text-muted-foreground" dangerouslySetInnerHTML={{
            __html: p.description
          }} />
            </div>)}
        </div>
      </div>
    </section>;
}